import { render, staticRenderFns } from "./ExamMaskInfoModal.vue?vue&type=template&id=6b1896ab"
import script from "./ExamMaskInfoModal.vue?vue&type=script&lang=js"
export * from "./ExamMaskInfoModal.vue?vue&type=script&lang=js"
import style0 from "./ExamMaskInfoModal.vue?vue&type=style&index=0&id=6b1896ab&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports